import { Injectable } from '@angular/core';
import WKT from 'ol/format/WKT';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import Text from 'ol/style/Text';
import Circle from 'ol/style/Circle';

@Injectable({ providedIn: 'root' })
export class OlGeometryService {

    public getWktFromFeature(feature, layerProjection, dataProjection = 'EPSG:4326') {
        const format = new WKT();
        const wktRepresenation = format.writeFeature(feature,
            {
                dataProjection: dataProjection, featureProjection: layerProjection
            });
        return wktRepresenation;
    }

    public getWktFromFeatures(features, layerProjection, dataProjection = 'EPSG:4326') {
        const format = new WKT();
        const wktRepresenation = format.writeFeatures(features,
            {
                dataProjection: dataProjection, featureProjection: layerProjection
            });
        return wktRepresenation;
    }

    public getFeatureFromWkt(wkt, layerProjection, dataProjection = 'EPSG:4326') {
        const format = new WKT();
        const feature = format.readFeature(wkt, {
            dataProjection: dataProjection,
            featureProjection: layerProjection
        });
        return feature;
    }

    public getFeaturesFromWkt(wkt, layerProjection, dataProjection = 'EPSG:4326') {
        const format = new WKT();
        const features = format.readFeatures(wkt, {
            dataProjection: dataProjection,
            featureProjection: layerProjection
        });
        return features;
    }

    public getWktFromGeometry(geometry, layerProjection, dataProjection = 'EPSG:4326') {
        const format = new WKT();
        const wktRepresenation = format.writeGeometry(geometry,
            {
                dataProjection: dataProjection, featureProjection: layerProjection
            });
        return wktRepresenation;
    }

    public getGeometryFromWkt(wkt, layerProjection, dataProjection = 'EPSG:4326') {
        const format = new WKT();
        const geometry = format.readGeometry(wkt, {
            dataProjection: dataProjection,
            featureProjection: layerProjection
        });
        return geometry;
    }

    public featureStyleFunction = (feature: any): Style[] => {
        const styles = [new Style({
            fill: new Fill({
                color: 'rgba(72, 174, 247, 0.4)'
            }),
            stroke: new Stroke({
                color: 'rgba(72, 174, 247, 0.4)',
                width: 2
            }),
            image: new Circle({
                radius: 5,
                fill: new Fill({
                    color: 'rgba(72, 174, 247, 0.4)'
                })
            })
        })];


        const geometryType = feature.getGeometry().getType();
        if (geometryType === 'Point' || geometryType === 'MultiPoint') {

            let offsetY = 0;
            const labelText = feature.get('case_count');
            const textStyle = this.getTextStyle(labelText, offsetY);
            styles.push(new Style({ text: textStyle }));

            let symbolStyle = null;
            const fontSize = 22;
            const symbol = '\u25BC';
            const color = 'red';
            symbolStyle = new Text({
                text: symbol,
                font: 'normal ' + fontSize + 'px Arial, Helvetica, sans-serif ',
                fill: new Fill({ color: color })
            });
            styles.push(new Style({ text: symbolStyle, zIndex: Infinity }));
        }
        return styles;
    }

    public getTextStyle = (labelText: string, offsetY = 0) => {

        if (!labelText) { return null; }
        const size = 16;
        offsetY = size + offsetY / 3.5;
        const font = 'normal 500 ' + size + 'px ' + ' Arial, Helvetica, sans-serif ';
        const fillColor = '#222';
        const outlineColor = '#ffffff';
        return new Text({
            font: font,
            text: labelText,
            fill: new Fill({ color: fillColor }),
            stroke: new Stroke({ color: outlineColor, width: 1 }),
            offsetY: offsetY
        });
    }
}
